// HOW-SLOTS-WEB-AGENDA-TASKS (2026-07-09): single-flight capabilities check. Multiple sections
// (AgendaSection/TasksSection/RescheduleBanner) each call this on mount; a module-level in-flight
// promise + the reducer's `checked` flag mean the network call fires exactly once per session
// (or once more after an explicit LOGOUT reset via the normal root-reducer teardown).
import actionTypes from "@actions/actionTypes"
import { fetchCapabilities } from "@utils/agendaTasksApi"

let inFlight = null

export const ensureCapabilitiesChecked = () => (dispatch, getState) => {
  const state = getState()
  if (state?.capabilities?.checked) return Promise.resolve(state.capabilities)
  if (inFlight) return inFlight
  dispatch({ type: actionTypes.CAPABILITIES_CHECKING })
  inFlight = fetchCapabilities()
    .then(caps => {
      dispatch({ type: actionTypes.CAPABILITIES_SET, payload: caps })
      return caps
    })
    .finally(() => {
      inFlight = null
    })
  return inFlight
}
